import React from "react";
import Text from "components/text/Text";
import styles from "./ShabanRefinements.module.scss";
import strings from "assets/strings";
import { DropdownLocalAlgolia } from "components/dropdownLocalAlgolia/DropdownLocalAlgolia";
//import { aroundRadiusOptions, aroundRadiusOptions, algoliaAttributes } from "assets/constants";
//import { CustomDropdown } from "components/customDropdown/CustomDropdown";
//import { CustomSearch } from "components/inputs/customSearch/CustomSearch";
import { checkIfParamExist, getAllClassNames } from "helpers";
import { CustomCheckboxes } from "components/buttons/customCheckboxes/CustomCheckboxes";
import { algoliaAttributes } from "assets/constants";
import { VirtualRefinementList } from "components/virtualRefinement/VirtualRefinmentList";
import { DropdownLocalAlgoliaWithSearch } from "components/dropdownLocalAlgoliaWithSearch/DropdownLocalAlgoliaWithSearch";

// const queryString = window.location.search;
// const urlSearchParams = new URLSearchParams(queryString);

export const ShabanRefinements = () => {
  const transformItems = (items: any[]) => {
    return items.map((item) => ({
      ...item,
      label: item.label === "false" ? strings.operationSearchResults.public : strings.operationSearchResults.shaban,
    }));
  };

  return (
    // add col-12 col-lg-4 col-xl-3 to the div

    <div className={getAllClassNames([styles.container, "col-12", "col-lg-4", "col-xl-3"])}>
      <aside className={styles.aside}>
        <Text
          className={styles.title}
          text={strings.globalStrings.filterBy}
        />
        <VirtualRefinementList attribute={algoliaAttributes.GroupCode} />
        <VirtualRefinementList attribute={algoliaAttributes.OperationCode} />
        <VirtualRefinementList attribute={algoliaAttributes.AddressCityCode} />
        <DropdownLocalAlgolia
          hideContinueBtn
          hide
          isPopup
          attribute={algoliaAttributes.OperationName}
          title={strings.searchOperations.operationName}
          titlePopup={strings.searchOperations.chooseOperationName}
          subTitlePopUp={strings.searchOperations.canChooseOperationName}
        />

        <DropdownLocalAlgoliaWithSearch
          attribute="fullName"
          title={strings.doctorSearchResults.searchByDoctorName}
        />

        {!checkIfParamExist('loc') && <DropdownLocalAlgoliaWithSearch
          attribute="address.city"
          title={strings.globalStrings.city}
        />
        }

        <CustomCheckboxes
          isFlex
          title={strings.operationSearchResults.route}
          attribute={algoliaAttributes.SurgeOnIsKupa}
          transformItems={(items) =>
            transformItems(items)
          }
          sortBy={["name:desc"]}
        />

      </aside>
    </div>
  );
};
